import { call, put, all, spawn, takeEvery } from 'redux-saga/effects';
import request from '../../utils/request';
import { showToast } from '../Toast/actions';
import {
  GET_PREFERENCES,
  GET_PREFERENCES_URL,
  POST_PREFERENCES,
  // POST_PREFERENCES_URL,
  UPDATE_PREFERENCES,
  UPDATE_PREFERENCES_URL,
  UPDATE_GROUP_PREFERENCES,
  UPDATE_GROUP_PREFERENCES_URL,
  POST_PREFERENCES_AND_VERIFY_URL,
  POST_PREFERENCES_URL,
} from './constants';

export function* fetchPreferences({ data }: any) {
  const { successCb, errorCb } = data;
  try {
    const response = yield call(request, GET_PREFERENCES_URL);
    successCb(response);
  } catch (err) {
    errorCb();
    yield put(
      showToast(new Error(`Unable to fetch the data, Please try again later!`)),
    );
  }
}

export function* fetchPreferencesSaga() {
  yield takeEvery(GET_PREFERENCES, fetchPreferences);
}

export function* addPreferences({ data }: any) {
  const { reqOptions, successCb, errorCb, env } = data;
  try {
    const { url, method } =
      env === 'test' ? POST_PREFERENCES_URL : POST_PREFERENCES_AND_VERIFY_URL;
    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      body: JSON.stringify(reqOptions),
    };
    yield call(request, url, options);
    successCb();
  } catch (err) {
    errorCb();
  }
}

export function* addPreferencesSaga() {
  yield takeEvery(POST_PREFERENCES, addPreferences);
}

export function* updatePreferences({ data }: any) {
  const { reqOptions, successCb, errorCb } = data;
  try {
    const { url, method } = UPDATE_PREFERENCES_URL;
    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      body: JSON.stringify(reqOptions),
    };
    yield call(request, url, options);
    successCb();
  } catch (err) {
    errorCb();
  }
}
export function* updatePreferencesSaga() {
  yield takeEvery(UPDATE_PREFERENCES, updatePreferences);
}

export function* updateGroupPreferences({ data }: any) {
  const { reqOptions, successCb, errorCb } = data;
  try {
    const { url, method } = UPDATE_GROUP_PREFERENCES_URL;
    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      body: JSON.stringify(reqOptions),
    };
    yield call(request, url, options);
    successCb();
  } catch (err) {
    errorCb();
  }
}
export function* updateGroupPreferencesSaga() {
  yield takeEvery(UPDATE_GROUP_PREFERENCES, updateGroupPreferences);
}

// Individual exports for testing
export default function* communicationSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    fetchPreferencesSaga,
    addPreferencesSaga,
    updatePreferencesSaga,
    updateGroupPreferencesSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
